import { Alert, Avatar, Box, Chip } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import {
  Datagrid, DateField, FunctionField, List, NumberField, SearchInput, TextField,
} from 'react-admin';
import { AppArtListRow, STATUS_COLOR, STATUS_LABEL } from './types';

const filters = [
  <SearchInput key="search" source="search" alwaysOn placeholder="Buscar rede" />,
];

const AppArtList = () => (
  <>
    <Alert severity="info" sx={{ mt: 2 }}>
      Material bruto que o cliente enviou (logos e fotos do posto) mais o briefing
      visual da rede. É a entrada para a geração dos modelos — não são os assets
      finais do aplicativo.
    </Alert>

    <List
      title="Imagens do aplicativo"
      filters={filters}
      sort={{ field: 'updatedAt', order: 'DESC' }}
      perPage={25}
      exporter={false}
    >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <FunctionField
          label="Rede"
          source="chainName"
          render={(record: AppArtListRow) => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar src={record.chainLogo || undefined} sx={{ width: 28, height: 28 }}>
                <ImageOutlinedIcon fontSize="small" />
              </Avatar>
              {record.chainName}
            </Box>
          )}
        />
        <FunctionField
          label="Status"
          source="status"
          render={(record: AppArtListRow) => (
            <Chip size="small" label={STATUS_LABEL[record.status]} color={STATUS_COLOR[record.status]} />
          )}
        />
        <NumberField source="logoCount" label="Logos" />
        <NumberField source="photoCount" label="Imagens" />
        <DateField source="submittedAt" label="Enviado em" emptyText="—" />
        <DateField source="updatedAt" label="Atualizado em" emptyText="—" />
      </Datagrid>
    </List>
  </>
);

export default AppArtList;
